import { AxiosResponse } from 'axios'

export const getErrorMessages =
  (defaultMessages: string[]) =>
  (response?: AxiosResponse<ErrorResponse & { message?: string }>) => {
    const errorMessages = response?.data?.errors || response?.data?.message
    if (Array.isArray(errorMessages)) {
      return errorMessages.join(', ') || defaultMessages.join(', ')
    } else {
      return errorMessages || defaultMessages.join(', ')
    }
  }
